/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OmStoresResponse } from '../../models/om-stores-response';

export interface GetOmStores$Params {
  'Active-Tenant-Identifier': string;
}

export function getOmStores(http: HttpClient, rootUrl: string, params: GetOmStores$Params, context?: HttpContext): Observable<StrictHttpResponse<OmStoresResponse>> {
  const rb = new RequestBuilder(rootUrl, getOmStores.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OmStoresResponse>;
    })
  );
}

getOmStores.PATH = '/om/stores';
